import React from 'react';
import item1 from './../assets/images/fast.jpg';
import item2 from './../assets/images/quality.jpg';
import item3 from './../assets/images/pro.jpg';

import './AboutUs.scss';



const AboutUs = () => {

  return (
    <>
      <div className='about-wrapper'>
        <h4 className='about-title'>
          General Concrete
        </h4>
        <div className='about-desc-wrapper'>
          <div className='about-desc-wrapper-content'>
            <p className="article-about">
            General Concrete are leading manufacturers of precast products. Manufactured in Canada, this efficient way of modular building has helped streamline the construction process. Our rapid build system is utilised in a range of construction activities, ranging from residential house and office blocks to sports arenas and transport projects. These modern methods of construction have proved innovative and time saving, whilst always maintaining high standards in quality. General Concrete has retained its core values and commitment to deliver quality, reliability and customer satisfaction to each and every project. General Concrete philosophy is that they are selling technology not just concrete. We have invested heavily in design software and in training staff over recent years and have the skills to design, draw and detail production schedules for customers.
            </p>
          </div>
        </div>
        <div className='sections-wrapper'>
          <div className="service-item">
            <div className="item-icon">
              <img src={item1} alt="fast-service" className="about-img"></img>
            </div>
            <div className="item-text">
              <h4 className="item-title">
                Fast servise
              </h4>
              <p className="item-content">
                We are the leading firm by delivering quality and value to our clients. All our professionals have more than 5 years of legal experiences. We like what we do.
              </p>
            </div>
          </div>
          <div className="service-item">
            <div className="item-icon">
              <img src={item2} alt="fast-service" className="about-img"></img>
            </div>
            <div className="item-text">
              <h4 className="item-title">
                Quality
              </h4>
              <p className="item-content">
                Our managers are always ready to answer your questions. You can call us at the weekends and at night. Also you can visit our office for personal consultation.
              </p>
            </div>
          </div>
          <div className="service-item">
            <div className="item-icon">
              <img src={item3} alt="fast-service" className="about-img"></img>
            </div>
            <div className="item-text">
              <h4 className="item-title">
                Professionalism
              </h4>
              <p className="item-content">
                Our company works according to the principle of individual approach to every client. This method lets us to get success in problems of all levels.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;